const ScratchArduinoK210Device = require('./arduinoK210');

/**
  * Scratch blocks to interact with a Arduino Maix Dock peripheral.
  */
class ScratchArduinoK210MaixDockDevice extends ScratchArduinoK210Device{

    /**
      * @return {string} - the ID of this extension.
      */
    get DEVICE_ID () {
        return 'arduinoK210MaixDock';
    }
}

module.exports = ScratchArduinoK210MaixDockDevice;
